<!-- ReusableIcon.vue -->
<template>
    <FontAwesomeLayers>
        <FontAwesomeIcon :icon="['fas', 'clock']" />
        <FontAwesomeIcon :icon="['fas', 'circle']"
                         :transform="overlayTransform"
                         :style="{ color: statusColor }" />
    </FontAwesomeLayers>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

export default defineComponent({
    components: {
        FontAwesomeIcon,
        FontAwesomeLayers
    },
    props: {
        overlayTransform: {
            type: String,
            default: 'down-6 right-6 shrink-8',
        },
        statusColor: {
            type: String,
            default: 'var(--dealer-success-color)',
        },
    },
});
</script>
